require('./grayscale');

$(function () {
    if ($('.top-code').length > 0) {
        var qrcode = new QRCode(document.getElementsByClassName('top-code')[0], {
            width: 124,
            height: 124,
        });
        var url = $('.top-code').data('url');
        qrcode.makeCode(url);
    }

    $('.top-user').hover(
        function () {
            $('.dropdown-list').show();
        },
        function () {
            setTimeout(function () {
                $('.dropdown-list').hide();
            }, 500);
        }
    );

    initSearch();

    $('body').on('click', '.aside-ads .close', function () {
        $(this).parent().remove();
    });

    $('body').on('click', '.large-ad-wrap .close', function () {
        $('.large-ad-wrap').remove();
    });

    $('body').on('click', '.top-small-ads .close', function () {
        $('.top-small-ads').remove();
    });

    getAd();

    var path = location.pathname;
    if (path === '') path = '/';
    $('.c-header .h-navs .h-nav').removeClass('active');
    $('.c-header .h-nav').each(function () {
        if ($(this).attr('href') === path) {
            $(this).addClass('active');
        }
    });

    $('.c-header .h-weixin').on('click', function () {
        $('.weixin-code').show();
    });
    $('.weixin-code').on('click', function () {
        $('.weixin-code').hide();
    });
});

function initSearch() {
    var handleSearch = function() {
        var keywords = $('.header-search .input__inner').val().trim();
        if (keywords.length > 0) {
            window.location.href = '/search?key=' + encodeURIComponent(keywords);
        }
    }
    // 绑定输入框回车事件
    $('.header-search .input__inner').on('keydown', function (e) {
        if (e.keyCode === 13) {
            handleSearch();
        }
    })
    // 绑定搜索按钮事件
    $('.header-search .icon-search').on('click', function () {
        handleSearch();
    })
}

function getAd() {
    $.get('/share/position-ads/top_large,top_small,aside', function (ads) {
        var path = location.pathname;

        if (ads['top_large'] && ads['top_large'].ads.length) {
            var ad = ads['top_large'].ads[0];
            var html = '<img src="'+ad.picture_url+'"/>';
            html += '<a href="'+ad.link_url+'" target="_blank" rel="noopener noreferrer"></a>';
            html += '<span class="close"></span>';
            $('.large-ad-wrap').html(html);
            // $('.large-ad-wrap').css({
            //     height: '260px',
            //     backgroundImage: 'url('+ad.picture_url+'?w=1920&h=260&s=3)'
            // });
        } else {
            $('.large-ad-wrap').remove();
        }

        if (path === '' || path === '/') {
            if (ads['aside'] && ads['aside'].ads.length) {
                var html = '';

                for (var i = 0; i < ads['aside'].ads.slice(0, 2).length; i++) {
                    var ad = ads['aside'].ads[i];
                    html +=
            '<div class="aside-ads ' +
            (i === 0 ? 'a-left' : 'a-right') +
            '">' +
            '	<a href="' +
            ad.link_url +
            '" target="_blank" rel="noopener noreferrer">' +
            '		<img src="' +
            ad.picture_url +
            '?w=160&h=290&s=3" alt="">' +
            '	</a>' +
            '	<span class="close"></span>' +
            '</div>';
                }

                $('body .c-header').append(html);
            }

            if (ads['top_small'] && ads['top_small'].ads.length) {
                var ads = ads['top_small'].ads.slice(0, 6);
                var html = '';
                for (var i = 0; i < ads.length; i++) {
                    html +=
                        '<a href="' +
                        ads[i].link_url +
                        '" target="_blank" rel="noopener noreferrer">' +
                        '	<img src="' +
                        ads[i].picture_url +
                        '?w=359&h=63&s=3" alt="" width="359" height="63">' +
                        '	<span class="title">广告</span>' +
                        '</a>';
                }
                $('.top-small-ads').html(html + '<span class="close"></span>');
            } else {
                $('.top-small-ads').remove();
            }
        } else {
            $('.top-small-ads').remove();
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./share/client/js/top.js
// module id = 8
// module chunks = 0